export const INIT_URL = "INIT_URL";
export const CHECKING_SCREEN = "CHECKING_SCREEN";
export const CHECKING_SCREEN_OFF = "CHECKING_SCREEN_OFF";
export const SIGNIN_USER_SUCCESS = "SIGNIN_USER_SUCCESS";
export const SIGNOUT_USER_SUCCESS = "SIGNOUT_USER_SUCCESS";
export const AUTO_SIGNIN_USER_SUCCESS = "AUTO_SIGNIN_USER_SUCCESS";
export const APP_MENUS = "APP_MENUS";
export const IS_MENU_FETCHED = "IS_MENU_FETCHED";
export const MENU_SLUG_URL = "MENU_SLUG_URL";